module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4e756888929288ec5a9bf4d027f28aa1.png";